import { L_Container } from "./Lessons.styled";
import { ServiceName } from "../../../../../../../../../constants";
import { GrandChartGroupLessonStore } from "../../../../../../../../../stores/grand-charts/grand-chart-group-lesson.store";
import { LessonItem } from "./LessonItem";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../../../../stores";
import { GrandChartAccess } from "../../../../../../../../../interfaces";

interface LessonsProps {
	isFirstGroupLesson: boolean;
	service: ServiceName;
	groupLessonStore: GrandChartGroupLessonStore;
}

export const Lessons = observer(({ isFirstGroupLesson, service, groupLessonStore }: LessonsProps) => {
	const { grandCharts, authStore } = useStores();

	const { selected } = grandCharts;
	const { userStore } = authStore;
	const hasShopAccess = userStore.hasAccessToGrandChart(selected.id);
	const effectiveAccess = hasShopAccess ? GrandChartAccess.FULL : selected.access;

	return (
		<L_Container>
			{groupLessonStore.lessons.map((lessonStore, index) => {
				return (
					<LessonItem
						key={lessonStore.id}
						isFirst={index === 0}
						isFirstGroupLesson={isFirstGroupLesson}
						service={service}
						access={effectiveAccess}
						lessonStore={lessonStore}
					/>
				);
			})}
		</L_Container>
	);
});
